var _g, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalableTeamsR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 288,
    viewBox: "0 0 407 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_4171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.049 0.127686C87.2211 0.127686 -231.607 0.127686 -550.434 0.127686C-550.085 249.982 -550.085 499.837 -550.434 749.691C-231.617 749.949 87.2112 749.949 406.049 749.691V0.127686Z",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 428.451H268.471C247.499 428.451 224.804 430.705 204.701 425.88C176.463 419.107 154.577 398.316 135.492 381.787C102.027 352.779 53.6856 287.414 0.670869 279.748C-45.7676 273.056 -103.681 325.238 -134.465 345.676C-176.649 373.675 -215.118 402.39 -269.197 412.932C-309.224 420.75 -340.412 435.671 -376.515 450.662C-407.583 463.576 -447.535 476.653 -480.776 460.054C-507.546 446.694 -514.811 432.067 -550.419 428.463",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 285.688C238.196 285.688 69.939 288.494 -97.7488 282.249C-191.719 278.727 -282.919 275.205 -376.23 265.25C-407.179 261.963 -467.07 250.376 -496.071 264.229C-502.603 267.351 -504.146 272.259 -509.763 275.733C-523.47 284.174 -532.458 285.031 -550.434 285.688",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 249.977C240.218 249.977 74.0736 252.325 -91.6519 247.37C-132.293 246.138 -173.024 246.067 -213.62 244.776C-266.171 243.109 -317.628 230.125 -368.635 221.133C-400.228 215.557 -462.186 200.143 -491.472 218.092C-515.815 232.954 -512.984 247.711 -550.434 250",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 214.292C243.215 214.292 80.2155 215.971 -82.5738 212.895C-120.024 212.191 -158.313 213.729 -195.584 211.24C-250.906 207.566 -305.014 187.08 -357.19 173.333C-391.644 164.259 -453.497 142.952 -485.106 167.464C-510.722 187.315 -508.115 209.139 -550.509 214.304",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 178.59C245.761 178.59 85.4735 179.306 -74.8141 178.249C-109.268 178.026 -145.715 180.597 -180.065 177.475C-237.903 172.239 -294.528 144.78 -347.318 127.065C-384.768 114.528 -445.243 88.7831 -479.413 118.66C-506.377 142.221 -504.145 170.924 -550.509 178.531",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 142.902H-72.1926C-105.823 142.902 -141.446 145.567 -174.927 142.526C-233.664 137.197 -290.918 107.108 -343.723 88.0318C-381.967 74.2145 -441.424 47.742 -476.597 78.8163C-504.145 103.164 -503.247 134.943 -550.449 142.89",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 107.251H-72.1926C-105.973 107.251 -141.341 109.669 -175.001 106.817C-229.649 102.191 -282.589 78.7358 -333.072 63.0871C-373.878 50.4438 -424.631 31.3907 -464.088 55.75C-495.547 75.167 -507.171 100.606 -550.464 107.227",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 71.5149H-72.1927C-106.198 71.5149 -140.697 72.8767 -174.657 71.4092C-222.593 69.3431 -269.032 55.291 -315.036 45.4768C-357.34 36.4609 -400.633 28.4429 -443.131 41.0745C-480.582 52.1683 -509.044 68.8735 -550.434 71.5149",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.049 35.8173H-72.1926C-148.412 35.8173 -221.994 34.0681 -297.704 27.224C-339.079 23.4791 -381.593 22.0234 -422.998 25.6392C-465.796 29.3723 -507.067 36.2047 -550.404 35.8525",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.4208 0.12793C-49.4208 67.6297 -43.279 137.151 -54.4542 204.218C-59.3677 233.708 -64.7455 262.645 -66.4383 292.393C-66.6031 295.34 -64.8204 312.608 -70.5279 315.872C-76.0106 319.03 -79.9654 315.872 -84.3246 317.586C-88.6838 319.3 -92.5636 315.837 -98.1063 319.3C-104.203 323.115 -102.69 337.414 -101.836 342.837C-95.8443 380.744 -46.0952 413.274 -17.7078 441.824C24.3714 484.086 21.7649 511.017 6.2604 562.259C-12.6296 624.596 -40.987 685.664 -49.316 749.632",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.86616 0.12793C-3.86616 59.4356 -2.83251 118.802 -3.70136 178.11C-4.09084 204.242 -5.8585 230.35 -6.69739 256.47C-7.10185 270.628 0.657873 301.409 -10.5323 312.632C-22.2618 306.163 -23.6999 292.675 -35.4144 286.242C-68.7302 326.156 49.4482 401.288 69.8812 432.092C96.0066 471.443 67.3795 523.167 53.8074 562.682C32.6105 624.443 5.75113 685.946 -3.92605 749.632",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6709 0.127686V256.846C41.6709 270.733 49.2359 301.819 37.8659 312.714C26.8106 304.496 25.8818 290.796 14.8114 282.59C-17.8902 319.675 96.9776 398.282 116.107 427.514C142.367 467.686 113.875 519.081 100.153 559.441C78.8067 622.294 51.8574 684.924 41.7308 749.62",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2258 0.127686V204.887C87.2258 234.787 88.1696 264.758 87.2258 294.694C87.2258 294.752 88.3344 315.379 84.2298 316.999C82.8067 317.539 74.1781 317.057 75.5114 316.106C76.2604 315.566 68.98 314.169 66.8079 315.226C61.7147 317.703 63.8119 333.446 64.4111 337.531C69.2796 372.467 103.359 403.8 125.021 433.266C157.063 476.772 153.228 505.734 139.821 554.499C121.98 619.453 96.0042 683.41 87.2258 749.656",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.767 0.127686V204.887C132.767 250.8 138.429 298.439 126.535 343.53C112.933 395.183 132.692 436.717 153.499 485.413C190.336 571.615 137.62 662.256 132.752 749.703",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.319 0.127686C178.319 122.312 182.813 245.118 176.821 367.232C174.211 421.69 176.629 476.225 184.056 530.41C193.868 603.723 176.806 676.449 178.304 749.738",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.859 0.127686V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.414 0.12793V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.957 0.12793V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.512 0.127686V749.691",
    stroke: "#707070",
    strokeOpacity: 0.23,
    strokeWidth: 0.859441,
    strokeMiterlimit: 10
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 398.512,
    height: 156.558,
    transform: "matrix(-1 0 0 1 405.5 131.442)",
    fill: "url(#paint0_linear_255_4171)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 250.326,
    height: 156.558,
    transform: "matrix(0 -1 -1 0 156.848 251.163)",
    fill: "url(#paint1_linear_255_4171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_4171",
    x1: 199.256,
    y1: 0,
    x2: 199.256,
    y2: 156.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_4171",
    x1: 125.163,
    y1: 0,
    x2: 125.163,
    y2: 156.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_4171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.336 25.1163C406.336 11.2449 395.091 0 381.22 0H0.289429V277.116H406.336V25.1163Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalableTeamsR);
export default __webpack_public_path__ + "static/media/scalable-teams-r.5a112e0aed06eb631306fbdfa21b7cd6.svg";
export { ForwardRef as ReactComponent };